// ToastContainerWrapper.js
import React, { lazy, Suspense } from "react";

const ToastContainer = lazy(() => import("react-toastify").then(mod => ({ default: mod.ToastContainer })));

const ToastContainerWrapper = () => (
  <Suspense fallback={null}>
    <ToastContainer position="bottom-right" autoClose={3000} hideProgressBar newestOnTop closeOnClick pauseOnFocusLoss draggable pauseOnHover />
  </Suspense>
);

export default ToastContainerWrapper;
